import * as checked from '../../lib/checked';
import { AreaVisual } from './visuals/area-visual-records';
import { ComboVisual } from './visuals/combo-visual-records';
import { DonutVisual } from './visuals/donut-visual-records';
import { HorizontalBarVisual } from './visuals/horizontal-bar-visual-records';
import { LineVisual } from './visuals/line-visual-records';
import { PieVisual } from './visuals/pie-visual-records';
import { PivotTableVisual } from './visuals/pivot-table-visual-records';
import { ScatterVisual } from './visuals/scatter-visual-records';
import { TableVisual } from './visuals/table-visual-records';
import { TextVisual } from './visuals/text-visual-records';
import { VerticalBarVisual } from './visuals/vertical-bar-visual-records';
import { MagicWandVisual } from './visuals/magic-wand-visual-records';
import { GaugeVisual } from './visuals/gauge-visual-records';
import { TimeSeriesLikeVisualTypes as TimeSeriesLikeVisualTypesConstant, VisualTypes as VisualTypesConstant, ChannelNames as ChannelNamesConstant } from './constants/visual-constants';
export const VisualTypes = VisualTypesConstant;
export const TimeSeriesLikeVisualTypes = TimeSeriesLikeVisualTypesConstant;
export const VisualType = checked.symbol(VisualTypes, 'VisualType');
export const Visual = checked.poly('type', {
  [VisualTypes.VERTICAL_BAR]: VerticalBarVisual,
  [VisualTypes.HORIZONTAL_BAR]: HorizontalBarVisual,
  [VisualTypes.LINE]: LineVisual,
  [VisualTypes.AREA]: AreaVisual,
  [VisualTypes.SCATTER]: ScatterVisual,
  [VisualTypes.PIE]: PieVisual,
  [VisualTypes.DONUT]: DonutVisual,
  [VisualTypes.TEXT]: TextVisual,
  [VisualTypes.TABLE]: TableVisual,
  [VisualTypes.PIVOT_TABLE]: PivotTableVisual,
  [VisualTypes.COMBO]: ComboVisual,
  [VisualTypes.MAGIC_WAND]: MagicWandVisual,
  [VisualTypes.GAUGE]: GaugeVisual
}, 'Visual');
export const ChannelNames = ChannelNamesConstant;
export const ChannelTypes = {
  SINGLE: 'SINGLE',
  MULTIPLE: 'MULTIPLE',
  STATIC: 'STATIC'
};
export const ChannelType = checked.symbol(ChannelTypes, 'ChannelTypes');
export const Channel = checked.record({
  name: checked.symbol(ChannelNames, 'ChannelNames'),
  label: checked.string(),
  type: ChannelType,
  helpText: checked.any().optional(),
  displayOrder: checked.number().optional()
}, 'Channel');